import { Component, inject, input, type InputSignal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

import { AuthService } from '@auth/repository';
import type { TermAndCondition } from '@core/models/app.model';
import { downloadFileAction } from '@helpers/download-file';
import type { IDownloadedFileResponse } from '@shared/files/download-file.service';

@UntilDestroy()
@Component({
  selector: 'ume-offering-terms-and-conditions-list',
  templateUrl: './offering-terms-and-conditions-list.component.html',
  styles: `
    button {
      min-width: 300px;
      text-align: left;
    }

    button .term-name {
      text-transform: initial;
    }
  `,
  imports: [MatIconModule, MatButtonModule],
})
export class OfferingTermsAndConditionsListComponent {
  private readonly authService: AuthService = inject(AuthService);

  public readonly terms: InputSignal<TermAndCondition[]> = input.required();

  public downloadTerms(term: TermAndCondition): void {
    this.authService
      .downloadTerms(term)
      .pipe(untilDestroyed(this))
      .subscribe((result: IDownloadedFileResponse) => {
        downloadFileAction(result.body, result.contentDisposition, term.name, 'pdf');
      });
  }
}
